import React from 'react'
import Skeleton from '../UI/Skeleton'
class BlogEmulaton extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Skeleton height={400} width={'80%'} className="d-block mx-auto" />
                <div className='pt-4'>
                    <Skeleton width={'70%'} />
                    <Skeleton />
                    <Skeleton />
                    <Skeleton width={'90%'} />
                </div>
                <div className='pt-4'>
                    <Skeleton width={'60%'} />
                    <Skeleton />
                    <Skeleton />
                    <Skeleton width={'80%'} />
                </div>
            </React.Fragment>
        )
    }
}

export default BlogEmulaton



// WEBPACK FOOTER //
// ./src/components/Study/BlogEmulation.jsx